import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'

Vue.use(Vuex)
const saved = JSON.parse(localStorage.getItem('photo-user') || 'null')
let bootstrapping = null

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('photo-token') || '',
    user: saved,
    sessionReady: false,
  },
  getters: {
    isPlatform: (state) => state.user && state.user.role === 'PLATFORM_ADMIN',
    isManager: (state) =>
      state.user && (state.user.role === 'PLATFORM_ADMIN' || state.user.role === 'STORE_MANAGER'),
  },
  mutations: {
    setAuth(state, value) {
      state.token = value.token
      state.user = value.user
      localStorage.setItem('photo-token', value.token)
      localStorage.setItem('photo-user', JSON.stringify(value.user))
    },
    clearAuth(state) {
      state.token = ''
      state.user = null
      state.sessionReady = false
      localStorage.removeItem('photo-token')
      localStorage.removeItem('photo-user')
    },
    setSessionReady(state, value) {
      state.sessionReady = !!value
    },
  },
  actions: {
    async login({ commit }, form) {
      const response = await api.login(form)
      commit('setAuth', response.data)
      commit('setSessionReady', true)
    },
    async bootstrap({ state, commit }) {
      if (!state.token) {
        commit('clearAuth')
        return false
      }
      if (state.sessionReady) return true
      if (bootstrapping) return bootstrapping
      bootstrapping = (async () => {
        try {
          const response = await api.me()
          commit('setAuth', { token: state.token, user: response.data })
          commit('setSessionReady', true)
          return true
        } catch (error) {
          commit('clearAuth')
          return false
        } finally {
          bootstrapping = null
        }
      })()
      return bootstrapping
    },
    logout({ commit }) {
      commit('clearAuth')
    },
  },
})
